export default function logOut() {
  window.localStorage.clear();
  window.location.href = "./";
}
